/* eslint import/prefer-default-export: 0 */
export function reloadOnBackButton() {
  $(window).one('popstate', () => {
    window.location.reload();
  });
}



// WEBPACK FOOTER //
// ./utils/window.js